//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TransferenciaPosseDefinitiva',
  props: {},
  data() {
    return {
      posses: [],
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      pagination: {},
      searchQueryDef: '',
      totalPage: 0,
      headers: [
        { text: this.$tc('label.de', 2), value: 'de' },
        { text: this.$tc('label.para', 1), value: 'para' },
        { text: this.$tc('label.motivo', 1), value: 'motivo' },
        { text: this.$tc('label.usuario', 1), value: 'usuario' },
        { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false },
      ],
    };
  },
  watch: {
    searchQueryDef() {
      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(() => {
        this.buscarPosses();
      }, 500);
    },
    pagination: {
      handler() {
        this.buscarPosses();
      },
      deep: true,
    },
  },
  methods: {
    buscarPosses() {
      const params = {
        numeroPagina: this.pagination.page || 1,
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0] || '',
        filtro: this.searchQueryDef,
      };

      this.resources.listar(params).then((response) => {
        this.posses = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
      }, (err) => {
        this.$error(this, err);
      });
    },
    abrirForm() {
      this.$router.push({ name: 'novaTransferenciaDefinitiva' });
    },
  },
  mounted() {
    this.buscarPosses();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitiva.vue?vue&type=script&lang=js&